import React, { useEffect, useState, memo, useContext } from "react"
import { Button, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import MainPrice from "./components/MainPrice/_MainPrice"
import WalletConnectPayBtn from "./components/PayBtn/WalletConnectPayBtn"
import ApiService from '../../Services/ApiService'
import AlertService from '../../Services/AlertService'
import MainService from '../../Services/MainService'
import { useDispatch } from 'react-redux'
import TransactionWaiting from "../TransactionWaiting"
import TopLogo from "../TopLogo"
import $ from "jquery"
import * as signalR from '@microsoft/signalr'
import KycVerification from "./components/KycVerification/KycVerification"
import { useDebounce } from 'use-debounce'
import NetworksAndCoins from "./components/NetworksAndCoins/_NetworksAndCoins"
import WalletConnectWalletConfig from "./components/WalletConfigs/WalletConnectWalletConfig"
import TronWalletConfig from "./components/WalletConfigs/TronWalletConfig"
import { TRON_PLATFORM_TYPE } from "../../Constants/MainKeys"
import TronPayBtn from "./components/PayBtn/TronPayBtn"
import BlackListComponent from "../../Components/BlackList/BlackListComponent"
import VeriffModal from "../../Components/Veriff/VeriffModal"
import TransactionCounter from "./components/TransactionCounter/TransactionCounter"
import { Link, useParams } from "react-router-dom"
import { BiNetworkChart } from "react-icons/bi";
import { LuWallet } from "react-icons/lu";
import { MdOutlineSystemSecurityUpdateGood } from "react-icons/md";
import { FaLock } from "react-icons/fa";
import { setCancelUrl, setUserData, setUserToken } from "../../Store/Reducers/userReducer"
import { addPageSpinner, removePageSpinner } from "../../Store/Reducers/spinnersReducer"
import uuid from "react-uuid"
import PaymentDataContext from '../../PaymentDataContext.jsx';

const Main = memo(({
  connection,
  signal_update,
  cryllexChains,
  selectedToken,
  selectedChain,
  onSetNetwork,
  onSetCrypto,
  countries,
  setSelectedChain,
  setSelectedToken,
  activeTab,
  setActiveTab,
}) => {

  var isPaymentCancelled = false;
  const dispatch = useDispatch();
  const { token } = useParams();

  const { paymentData, setPaymentData } = useContext(PaymentDataContext);
  const [isLoading, setIsLoading] = useState(false);
  const [showOTPloader, setShowOTPloader] = useState(false);
  const [price, setPrice] = useState(null);
  const [tick, setTick] = useState(null);
  const [organizationData, setOrganizationData] = useState(null);
  const [isTransactionValidated, setIsTransactionValidated] = useState(false);
  const [isShowTransactionWaitingModal, setIsShowTransactionWaitingModal] = useState(false);
  const [kyc_numbers, set_kyc_numbers] = useState("");
  const [debounce_kyc_numbers] = useDebounce(kyc_numbers, 500);
  const [to, setTo] = useState(null);
  const [allBalance, setAllBalance] = useState(null);
  const [amount, setAmount] = useState(0);
  const [address, setAddress] = useState("");
  const [isLoadingPay, setIsLoadingPay] = useState(false);
  const [smsDeadline, setSmsDeadline] = useState(null);

  useEffect(() => {
    if (debounce_kyc_numbers.length === 8) {
      validateKyc(debounce_kyc_numbers);
    }
  }, [debounce_kyc_numbers])

  useEffect(() => {
    if (connection && connection.state === signalR.HubConnectionState.Connected) {

      init();
      connection.on("updatecrypto", (id, _price) => {
        console.log(_price, "price");

        try {
          if (_price) {
            setPrice(JSON.parse(_price).price)
            setTick(JSON.parse(_price).tick)
          }
        } catch (error) {
          AlertService.alert("error", error)
        }
      });
    }
  }, [connection, selectedToken, address])

  useEffect(() => {
    if (address) {
      getAccountBalance(address);
    }
  }, [address, selectedChain])

  const getAccountBalance = async (address) => {
    if (!address || !selectedChain) { return false; }
    ApiService.getAccountBalance(address, selectedChain.id).then(response => {
      if (response && response.data && response.data.data) {
        setAllBalance(response.data.data)
      }
    }).catch(error => getFail(error))
  }

  const init = () => {
    try {
      setTimeout(() => {
        verifyIsKycAlreadyDone();
      }, 500);
    } catch (e) {
      setTimeout(() => { init(); }, 1000);
    }
  }

  const getSecondsDifference = (isoTime) => {
    if (!isoTime) { return }
    const givenTime = new Date(`${isoTime}Z`);
    const currentTime = new Date();
    const diffInMs = givenTime.getTime() - currentTime.getTime();
    const diffInSeconds = diffInMs / 1000;
    return Math.round(diffInSeconds) || 0;
  }

  const verifyIsKycAlreadyDone = (showSpinner = false) => {
    const spinnerId = uuid();
    if (showSpinner) {
      dispatch(addPageSpinner(spinnerId));
    }
    ApiService.verifyIsKycAlreadyDone().then(response => {
      if (response && response.data) {
        const deadLine = getSecondsDifference(response.data?.smsTokenDeadline);
        if (response.data.smsStatus === 2) {
          setIsTransactionValidated(true);
        } else if (response.data.smsStatus === 1) {
          setSmsDeadline(deadLine);
        }
      }
    }).catch(error => getFail(error)).finally(() => {
      if (showSpinner) {
        setTimeout(() => {
          dispatch(removePageSpinner(spinnerId));
        }, 1000);
      }
    });
  }

  useEffect(() => {
    if (isTransactionValidated && activeTab === 1) {
      setActiveTab(2);
    }
  }, [isTransactionValidated, activeTab])

  useEffect(() => {
    getPaymentData(null, true);
  }, [selectedChain, cryllexChains]);

  const getPaymentData = (_loadOrgData, showSpinner) => {
    if (!cryllexChains || (cryllexChains && !cryllexChains.length)) { return false; }
    const spinnerId = uuid();
    if (_loadOrgData == undefined) _loadOrgData = true;
    if (!token) { return false; }
    if (showSpinner) {
      dispatch(addPageSpinner(spinnerId));
    }
    ApiService.getPaymentData(token).then(response => {
      if (response && response.data) {
        const data = { ...response.data };
        if (data.cancelUrl) {
          dispatch(setCancelUrl(data.cancelUrl))
          if (isPaymentCancelled) {
            window.location.href = data.cancelUrl;
          }
        } else {
          dispatch(setCancelUrl(""));
        }
        onSetSelectedNetworkAndToken(data);
        successFunc(data, _loadOrgData);
      };
    }).catch(error => {
      getFail(error)
    }).finally(() => {
      if (showSpinner) {
        setTimeout(() => {
          dispatch(removePageSpinner(spinnerId))
        }, 1000);
      }
    })
  }

  const onSetSelectedNetworkAndToken = (paymentData) => {
    if (!paymentData?.cryptoNetworkId || !cryllexChains.length) return false;
    const currentNetwork = cryllexChains.find(({ id }) => id === paymentData.cryptoNetworkId);
    if (!currentNetwork) return false;
    setSelectedChain(currentNetwork);
    const currentToken = currentNetwork.tokens?.find(({ id }) => id === paymentData.cryptoCurrencyId);
    if (currentToken) {
      setSelectedToken(currentToken);
      setActiveTab(3);
    }
  };

  const successFunc = (data, _loadOrgData) => {
    setPaymentData(null);
    setIsShowTransactionWaitingModal(false);
    setTimeout(() => {
      setPaymentData(data);
      data.cryptoAmount && setPrice(data.cryptoAmount);
      if (data.paymentRequested) {
        setIsShowTransactionWaitingModal(true);
        checkPaymentStatus(data);
      }
      if (_loadOrgData) {
        loadOrgData(data.organizationId);
      }
    }, 500);
  };

  const checkPaymentStatus = (paymentData) => {
    if (!paymentData) return false;

    if ([3, 4, 5, 6, 7].includes(paymentData.status)) return false;

    try {
      const paymentTime = new Date(paymentData.paymentRequestedDatetime);
      const localPaymentTime = MainService.convertUTCDateToLocalDate(paymentTime);
      const passedSeconds = Math.floor((Date.now() - localPaymentTime.getTime()) / 1000);

      if (passedSeconds > 300 && isShowTransactionWaitingModal && paymentData.status === 0) {
        cancelPayment(false);
        return;
      }
    } catch (error) {
      AlertService.alert("error", error);
      return;
    }

    setTimeout(async () => {
      try {
        const response = await ApiService.getPaymentData(token);
        if (response?.data) {
          setPaymentData({ ...response.data });
          checkPaymentStatus(response.data);
        }
      } catch (error) {
        AlertService.alert("error", error);
      }
    }, 10000);
  };


  const loadOrgData = (organizationId) => {
    setIsLoading(true);
    ApiService.loadOrgData(organizationId).then(response => {
      if (response && response.data) {
        setOrganizationData(response.data.organizationDetail)
      }
    }).catch(error => getFail(error)).finally(() => {
      setIsLoading(false)
    });
  }

  const validateKyc = (data) => {
    setShowOTPloader(true);
    ApiService.validateKyc({ Code: data.toString() }).then(response => {
      if (response && response.data) {
        setIsTransactionValidated(true);
        verifyIsKycAlreadyDone();
        // setActiveTab(2);
        dispatch(setUserToken(response.data));
        setTimeout(() => {
          getCurrentUser();
        }, 100);
      } else {
        AlertService.alert("error", "OTP code is invalid", "kyc_error");
      }
      setTimeout(() => {
        setShowOTPloader(false);
      }, 1000);
    }).catch(error => getFail(error)).finally(() => {
      setTimeout(() => {
        clearOTPInputs();
      }, 1000);
    })
  }

  const getCurrentUser = () => {
    ApiService.getCurrentUser().then(response => {
      if (response && response.data) {
        dispatch(setUserData(response.data));
      }
    }).catch(error => AlertService.alert("error", error))
  }

  const pay = (cb) => {

    if (!selectedChain) {
      AlertService.alert("warning", "Please select any network.");
      return false;
    }

    if (!selectedToken) {
      AlertService.alert("warning", "Please select any token.");
      return false;
    }

    setIsLoadingPay(true);
    ApiService.pay().then(resp => {
      if (resp && resp.data) {
        const data = { ...resp.data }
        signal_update();
        setTo(data.account);
        setAmount(data.amount);
        getPaymentData(false);
        cb && cb(data.account, data.amount);
      }
    }).catch(error => getFail(error)).finally(() => {
      setIsLoadingPay(false);
    });
  }

  const paySuccess = (txHash = "", chainId = null,) => {
    if (!txHash) { return false; }
    let data = {
      txHash,
      chainId
    }
    ApiService.paySuccess(data).then(() => {
      signal_update();
      // getPaymentData(false);
    }).catch(error => getFail(error))
  }

  const payError = (err_code, err_message) => {
    ApiService.payError({ Code: `${err_code}`, Message: err_message }).then(() => {
      getPaymentData(false);
      signal_update();
      // AlertService.alert("error", `${err_code} : ${err_message}`);
    }).catch(error => getFail(error ? error : err_message))
  }

  const cancelPayment = (showConfirm = true) => {
    const cancel = () => {
      ApiService.cancelPayment(token).then(() => {
        isPaymentCancelled = true;
        getPaymentData(false);
        setIsLoading(false);
        setIsTransactionValidated(false);
        setShowOTPloader(false);
        clearOTPInputs();
      });
    };

    if (showConfirm) {
      AlertService.alertConfirm(
        `Payment cancellation`,
        "Are you sure you want to cancel this payment?",
        "Yes",
        "No"
      ).then(() => {
        cancel();
      }).catch(() => { });
    } else {
      cancel();
    }
  };

  const getFail = (error) => {
    error && AlertService.alert("error", error);
    isPaymentCancelled = false;
    setIsLoading(false);
    // clearOTPInputs();
    setTimeout(() => {
      setShowOTPloader(false);
    }, 1000);
  }

  const clearOTPInputs = () => {
    set_kyc_numbers("");
    if ($(document.querySelectorAll('.kyc-number')[0])) {
      setTimeout(() => {
        $(document.querySelectorAll('.kyc-number')[0]).focus();
      }, 100);
    };
  }

  const setPayButtonComponent = () => {
    // Don't render anything if no chain is selected
    if (!selectedChain) {
      return null;
    }

    const commonProps = {
      price,
      isTransactionValidated,
      pay,
      selectedChain,
      selectedToken,
      amount,
      paySuccess,
      payError,
      to,
      isLoadingPay,
      cryllexChains
    };

    // Explicitly check platform type to prevent rendering wrong component
    switch (selectedChain.platformType) {
      case TRON_PLATFORM_TYPE:
        return <TronPayBtn {...commonProps} />
      default:
        // Only render WalletConnectPayBtn for non-Tron chains
        return <WalletConnectPayBtn {...commonProps} />
    }
    // switch (selectedChain?.platformType) {
    //   case AVALANCHE_PLATFORM_TYPE:
    //   case ETHEREUM_PLATFORM_TYPE:
    //     return <WalletConnectPayBtn {...commonProps} />
    //   case SOLANA_PLATFORM_TYPE:
    //     return <SolanaPayBtn {...commonProps} />
    //   case STELLAR_PLATFORM_TYPE:
    //     return <StellarPayBtn  {...commonProps} />
    //   case TRON_PLATFORM_TYPE:
    //     return <TronPayBtn {...commonProps} />
    //   default:
    //     return <div></div>;
    // }
  };

  const setWalletConfigComponent = () => {
    const commonProps = {
      amount,
      allBalance,
      selectedChain,
      selectedToken,
      setAddress,
      setActiveTab,
    };
    if (selectedChain && selectedToken) {
      switch (selectedChain?.platformType) {
        case TRON_PLATFORM_TYPE:
          return <TronWalletConfig {...commonProps} />
        default:
          return <WalletConnectWalletConfig {...commonProps} />
      }


      // switch (selectedChain?.platformType) {
      //   case AVALANCHE_PLATFORM_TYPE:
      //   case ETHEREUM_PLATFORM_TYPE:
      //     return <WalletConnectWalletConfig {...commonProps} />
      //   case SOLANA_PLATFORM_TYPE:
      //     return <SolanaWalletConfig {...commonProps} />
      //   case STELLAR_PLATFORM_TYPE:
      //     return <StellarWalletConfig {...commonProps} />
      //   case TRON_PLATFORM_TYPE:
      //     return <TronWalletConfig {...commonProps} />
      //   default:
      //     break;
      // }
    } else {
      return <div>
        <div className="title-block">
          <strong >
            Connect your wallet
          </strong>
        </div>
        <div className='mt-3'>
          <div className="p-3 text-dark">
            <p>
              Before connecting your wallet, please select the <Link className="text-primary" to="#" onClick={() => setActiveTab(2)}>network & token</Link> you intend to use. Once selected, the available connection methods will be displayed.
            </p>
            <p>
              Wallet connections are supported via mobile wallets using QR code scanning across supported environments.
            </p>
            <p>
              Depending on the selected network and wallet provider, additional connection options may be available, including:
            </p>
            <ul>
              <li>
                Browser extension wallets for secure desktop interaction
              </li>
              <li>
                Network-specific or ecosystem wallets designed for direct integration
              </li>
            </ul>
            <p>
              After a network is selected, all applicable connection methods will be presented automatically.
            </p>
          </div>
        </div>
        <Button
          className="w-100"
          variant="primary"
          onClick={() => setActiveTab(2)}
        >
          Select Network & Token
        </Button>
      </div>
    }
  };

  const setContent = () => {
    switch (activeTab) {
      case 1:
        return <div>
          <KycVerification
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            isTransactionValidated={isTransactionValidated}
            countries={countries}
            getFail={getFail}
            kyc_numbers={kyc_numbers}
            set_kyc_numbers={set_kyc_numbers}
            showOTPloader={showOTPloader}
            setActiveTab={setActiveTab}
            smsDeadline={smsDeadline}
            clearOTPInputs={clearOTPInputs}
          />
        </div>
      case 2:
        return <div>
          <NetworksAndCoins
            selectedChain={selectedChain}
            selectedToken={selectedToken}
            onSetNetwork={onSetNetwork}
            onSetCrypto={onSetCrypto}
            setActiveTab={setActiveTab}
            cryllexChains={cryllexChains}
          />
        </div>
      case 3:
        return <div>
          {setWalletConfigComponent()}
        </div>
      default:
        break;
    }
  }


  return <main>
    <div className="px-lg-5 px-3 ">
      <TopLogo />

      <VeriffModal countries={countries} />
      <BlackListComponent walletAddress={address} />

      <TransactionWaiting
        cancelPayment={cancelPayment}
      />
      <Row className="mt-4 mb-5 flex-lg-row flex-row-reverse">
        <Col
          lg={{ span: 4, order: 1 }}
          xs={{ span: 12, order: 2 }}
          className="p-0 mb-2"
        >
          <MainPrice
            price={price}
            selectedChain={selectedChain}
            selectedToken={selectedToken}
            getPaymentData={getPaymentData}
          />
        </Col>
        <Col
          lg={{ span: 8, order: 2 }}
          xs={{ span: 12, order: 1 }}
          className="p-0 mb-2"
        >
          <div className='main-content'>
            <div className="transaction-expire-block">
              {
                paymentData ?
                  <TransactionCounter />
                  : null
              }
            </div>
            <div className="popup">
              <div className="tabs">
                <React.Fragment>
                  <input
                    type="radio"
                    id="tab1"
                    name="tab"
                    checked={activeTab === 1 ? true : false}
                    onChange={() => setActiveTab(1)}
                    disabled={isTransactionValidated}
                  />
                  <label
                    className={`label ${isTransactionValidated ? "active-label" : ""}`}
                    htmlFor="tab1"
                  >
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={<Tooltip id="Otp">
                        {
                          isTransactionValidated ? "OTP verification completed successfully" : "Please complete OTP verification"
                        }
                      </Tooltip>}
                    >
                      <span className="d-none d-lg-block"><MdOutlineSystemSecurityUpdateGood size={30} /></span>
                    </OverlayTrigger>
                    <span className="d-block d-lg-none"><MdOutlineSystemSecurityUpdateGood size={30} /></span>
                  </label>
                </React.Fragment>
                <React.Fragment>
                  <input
                    type="radio"
                    id="tab2"
                    name="tab"
                    checked={activeTab === 2 ? true : false} onChange={() => setActiveTab(2)}
                    disabled={!isTransactionValidated}
                  />
                  <label
                    className={`label d-flex align-items-center justify-content-end gap-2 ${selectedToken && selectedChain ? "active-label" : ""}`}
                    htmlFor="tab2"
                  >
                    {
                      !isTransactionValidated ? <FaLock size={14} /> : null
                    }
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={<Tooltip id="NetworkAbdToken">
                        Network & Token
                      </Tooltip>}
                    >
                      <span className="d-none d-lg-block text-nowrap"><BiNetworkChart size={30} /></span>
                    </OverlayTrigger>
                    <span className="d-block d-lg-none"><BiNetworkChart size={30} /></span>
                  </label>

                </React.Fragment>
                <React.Fragment>
                  <input
                    type="radio"
                    id="tab3"
                    name="tab"
                    checked={activeTab === 3 ? true : false} onChange={() => setActiveTab(3)}
                    disabled={!isTransactionValidated}
                  />
                  <label
                    className={`label d-flex align-items-center justify-content-end gap-2 ${address ? "active-label" : ""}`}
                    htmlFor="tab3"
                  >
                    {
                      !isTransactionValidated ? <FaLock size={14} /> : null
                    }
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={<Tooltip id="ConnectWallet">
                        Connect Wallet
                      </Tooltip>}
                    >
                      <span className="d-none d-lg-block text-nowrap"><LuWallet size={30} /></span>
                    </OverlayTrigger>
                    <span className="d-block d-lg-none"><LuWallet size={30} /></span>
                  </label>

                </React.Fragment>
                <div className="marker">
                  <div id="top"></div>
                  <div id="bottom"></div>
                </div>
              </div>
              <div className='content-block'>
                {setContent()}
              </div>
              <div className="prev-next-block">
                {
                  [1, 2, 3].includes(activeTab) && selectedChain ?
                    setPayButtonComponent()
                    : null
                }
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </main>
})


export default Main;
